export default __webpack_public_path__ + "static/media/cvadro.0d729c9d.jpg";